import { parseCurrency } from '@helper/parseCurrency'

import { displayDateBrazilian } from '../../util/standardizedDate'

const formattedDate = (date: string) => {
  return displayDateBrazilian(date)
}

const formattedValue = (date: number) => {
  return date.toFixed(2)
}

export const parseStorageKpiData = (data: any[]): any[] => {
  return data?.length === 0
    ? []
    : data.map(item => {
        return {
          'data-data': item.data ? item.data : 0,
          'data-execucao-id': item.periodo ? formattedDate(item.periodo) : 0,

          'cd-loja-codigo-id': item.lojaId ? item.lojaId : 0,
          'cd-loja-nome-id': item.lojaDescricao ? item.lojaDescricao : '',
          'cd-loja-tipo-id': item.centroDistribuicaoDescricao
            ? item.centroDistribuicaoDescricao
            : '',

          'gerente-categoria-id': item.gerenteCategoriaDescricao
            ? item.gerenteCategoriaDescricao
            : '',
          'gerente-produto-id': item.gerenteProdutoDescricao
            ? item.gerenteProdutoDescricao
            : '',

          'mundo-codigo-id': item.mundoId ? item.mundoId : 0,
          'mundo-nome-id': item.mundoDescricao ? item.mundoDescricao : '',

          'categoria-compacta-codigo-id': item.categoriaCompactaId
            ? item.categoriaCompactaId
            : 0,
          'categoria-compacta-nome-id': item.categoriaCompactaDescricao
            ? item.categoriaCompactaDescricao
            : '',

          'categoria-codigo-id': item.categoriaId ? item.categoriaId : 0,
          'categoria-nome-id': item.categoriaDescricao
            ? item.categoriaDescricao
            : '',

          'status-nome-id': item.statusDescricao ? item.statusDescricao : '',

          'curva-abc-nome-id': item.curvaABCDescricao
            ? item.curvaABCDescricao
            : '',

          'fornecedor-id': item.fornecedorId ? item.fornecedorId : '',
          'fornecedor-descricao-id': item.fornecedorDescricao
            ? item.fornecedorDescricao
            : '',

          'empresa-codigo-id': item.empresaId ? item.empresaId : 0,
          'empresa-nome-id': item.empresaDescricao ? item.empresaDescricao : '',

          'valor-estoque-atual-id': item.estoqueReaisAtual
            ? item.estoqueReaisAtual
            : parseCurrency({ value: 0, country: 'pt-br' }),
          'valor-estoque-transito-id': item.estoqueReaisTransitoCompra
            ? item.estoqueReaisTransitoCompra
            : parseCurrency({ value: 0, country: 'pt-br' }),
          'valor-estoque-transito-trans-id':
            item.estoqueReaisTransitoTransferencia
              ? item.estoqueReaisTransitoTransferencia
              : parseCurrency({ value: 0, country: 'pt-br' }),
          'valor-estoque-reservado-id': item.estoqueReaisReservado
            ? item.estoqueReaisReservado
            : parseCurrency({ value: 0, country: 'pt-br' }),
          'valor-estoque-excesso-id': item.estoqueExcedidoRS
            ? item.estoqueExcedidoRS
            : parseCurrency({ value: 0, country: 'pt-br' }),
          'valor-estoque-falta-id': item.estoqueEscassoRS
            ? item.estoqueEscassoRS
            : parseCurrency({ value: 0, country: 'pt-br' }),

          'dias-estoque-atual-id': item.estoqueDiasAtual
            ? item.estoqueDiasAtual
            : 0,
          'dias-estoque-transito-id': item.estoqueDiasTransitoCompra
            ? item.estoqueDiasTransitoCompra
            : 0,
          'dias-estoque-transito-trans-id':
            item.estoqueDiasTransitoTransferencia
              ? item.estoqueDiasTransitoTransferencia
              : 0,
          'dias-estoque-reservado-id': item.estoqueReservaDias
            ? item.estoqueReservaDias
            : 0,
          'dias-estoque-excesso-id': item.estoqueExcedidoDias
            ? item.estoqueExcedidoDias
            : 0,
          'dias-estoque-falta-id': item.estoqueEscassoDias
            ? item.estoqueEscassoDias
            : 0,

          'ruptura-num-sku-id': item.estoqueEscasso ? item.estoqueEscasso : 0,
          'ruptura-porcentagem-id': item.rupturaPercentual
            ? formattedValue(item.rupturaPercentual)
            : 0,

          'retabilidade-margem-id': item.margemRS
            ? item.margemRS
            : parseCurrency({ value: 0, country: 'pt-br' }),
          'retabilidade-estoque-medio-id': item.estoqueMedio
            ? item.estoqueMedio
            : parseCurrency({ value: 0, country: 'pt-br' }),
          'retabilidade-gmroi-id': item.gmroi ? formattedValue(item.gmroi) : 0,
          'dcmv-4m': item.vendaCMV4M ? item.vendaCMV4M : 0,
          'vendas-projetado': item.vendaCMVProjetado
            ? item.vendaCMVProjetado
            : 0,
          'vendas-custo': item.vendaCusto ? item.vendaCusto : 0,
          'valor-estoque-dep16': item.estoqueReaisDeposito16
            ? item.estoqueReaisDeposito16
            : parseCurrency({ value: 0, country: 'pt-br' }),
          'valor-estoque-outros': item.estoqueReaisOutros
            ? item.estoqueReaisOutros
            : parseCurrency({ value: 0, country: 'pt-br' }),
          'dias-estoque-total': item.estoqueDiasTotal
            ? item.estoqueDiasTotal
            : 0,
          'sontimento-position': item.sortimentoPosicao
            ? item.sortimentoPosicao
            : parseCurrency({ value: 0, country: 'pt-br' }),
          'sontimento-ruptura': item.sortimentoRuptura
            ? item.sortimentoRuptura
            : parseCurrency({ value: 0, country: 'pt-br' }),
          'sontimento-ruptura-percent':
            item.sortimentoPercentual !== 0 ? item.sortimentoPercentual : 0,
          'dcmv-real': item.cmvReal,

          'subcategoria-codigo-id': item.subCategoriaId
            ? item.subCategoriaId
            : 0,
          'subcategoria-nome-id': item.subCategoriaDescricao
            ? item.subCategoriaDescricao
            : ''
        }
      })
}
